// Customer side of the refund flow. Every call needs the buyer's Auth0 ID
// token: a refund cancels the eSIM, so arta-api only lets the person who paid
// for the order see or start one.
const API_BASE = 'https://api.artamobile.id/v2';

// Copy for everything below lives in the dictionaries under `refund.*`; the
// review SLA shown to customers is refund.slaLabel.

// Labels: refund.reasons.<value>.
export const REFUND_REASONS = ['TRIP_CANCELLED', 'WRONG_PACKAGE', 'DEVICE_NOT_SUPPORTED', 'OTHER'];

// Why the menu item is greyed out, as a dictionary key. A reason mapped to null
// hides the item instead: there is nothing a customer can do about it from
// this page.
export const INELIGIBLE_LABELS = {
    ESIM_IN_USE: 'refund.ineligible.ESIM_IN_USE',
    WINDOW_EXPIRED: 'refund.ineligible.WINDOW_EXPIRED',
    NOT_SELF_SERVICE: 'refund.ineligible.NOT_SELF_SERVICE',
    PROVIDER_UNAVAILABLE: 'refund.ineligible.PROVIDER_UNAVAILABLE',
    PHYSICAL_SIM: null,
    NOT_PAID: null,
};

// The admin-side statuses collapse to four for the customer. The failure
// states are CS's to resolve, so the customer only ever sees "diproses".
// Labels: refund.status.<key>.
export const customerStatus = (status) => {
    switch (status) {
        case 'PENDING_REVIEW':
            return { key: 'review', tone: 'pending' };
        case 'REFUNDED':
            return { key: 'done', tone: 'success' };
        case 'REJECTED':
            return { key: 'rejected', tone: 'danger' };
        default:
            return { key: 'processing', tone: 'pending' };
    }
};

const request = async (path, token, options = {}) => {
    const res = await fetch(`${API_BASE}${path}`, {
        ...options,
        headers: {
            ...(options.body ? { 'Content-Type': 'application/json' } : {}),
            Authorization: `Bearer ${token}`,
        },
    });
    const body = await res.json().catch(() => ({}));

    if (!res.ok) {
        const error = new Error(body?.message || `HTTP ${res.status}`);
        error.status = res.status;
        error.reason = body?.reason;
        error.ineligibleReason = body?.ineligibleReason;
        throw error;
    }

    return body;
};

export const fetchSimRefund = (simId, token) =>
    request(`/sim/${encodeURIComponent(simId)}/refund`, token);

export const createSimRefund = (simId, token, { reason, note }) =>
    request(`/sim/${encodeURIComponent(simId)}/refund`, token, {
        method: 'POST',
        body: JSON.stringify({ reason, note }),
    });

export const formatRupiah = (amount) =>
    `Rp ${Number(amount || 0).toLocaleString('id-ID')}`;

export const formatDateTime = (iso, locale = 'id-ID') => {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    return d.toLocaleString(locale, {
        day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
    });
};
